import PrimaryPalette from '../../colors';

export default {
  default: {
    emptyButtonBackgroundColor: 'transparent',
    listItemBackgroundColor: PrimaryPalette.white,
    borderColor: PrimaryPalette.lightGrey,
    headerColor: PrimaryPalette.lightEvergreen,
    descriptionColor: PrimaryPalette.darkerGrey,
    textColor: PrimaryPalette.mediumEvergreen,
    linkHover: PrimaryPalette.mediumEvergreen,
  },
  hover: {
    listItemBackgroundColor: PrimaryPalette.extraLightIris,
  },
};
